import React from 'react';
import { Link } from 'react-router-dom';
import klikLogo from '../assets/klik_logo.png';

export default function Footer() {
  return (
    <footer className="kh-footer">
      <div className="kh-container kh-footer-grid">
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <img src={klikLogo} alt="KLIK Innovatech" style={{ height: 30, width: 'auto' }} />
            <span style={{ fontSize: 13.5, fontWeight: 700, color: '#FFFFFF', letterSpacing: '0.03em' }}>KLIK INNOVATECH</span>
          </div>
          <p style={{ fontSize: 13.5, color: 'var(--footer-muted)', lineHeight: 1.7, marginTop: 16, maxWidth: 280 }}>
            Kovil Kudiyiruppu, 37 St Mary's Rd,<br />Mullaitivu 42000, Sri Lanka.
          </p>
          <div style={{ display: 'flex', gap: 10, marginTop: 22 }}>
            <a className="kh-social" href="https://www.facebook.com/share/1NWJ1X528o/" target="_blank" rel="noopener noreferrer">
              <svg width="16" height="16"><use href="#i-fb" /></svg>
            </a>
            <a className="kh-social" href="https://www.linkedin.com/company/klik-innovatech-pvt-ltd/" target="_blank" rel="noopener noreferrer">
              <svg width="16" height="16"><use href="#i-li" /></svg>
            </a>
            <a className="kh-social" href="https://wa.me/94717123790" target="_blank" rel="noopener noreferrer">
              <svg width="16" height="16"><use href="#i-wa" /></svg>
            </a>
          </div>
        </div>

        <div>
          <h3 className="kh-footer-heading">Company</h3>
          <div className="kh-footer-col">
            <Link to="/" className="kh-footer-link">Home</Link>
            <Link to="/about" className="kh-footer-link">About Us</Link>
            <a href="#!" className="kh-footer-link">Blog</a>
            <a href="#contact" className="kh-footer-link">Contact Us</a>
          </div>
        </div>

        <div>
          <h3 className="kh-footer-heading">Solutions</h3>
          <div className="kh-footer-col">
            <Link to="/services" className="kh-footer-link">Services</Link>
            <a href="#!" className="kh-footer-link">Products</a>
            <a href="#!" className="kh-footer-link">Pages</a>
            <a href="#!" className="kh-footer-link">Careers</a>
          </div>
        </div>

        <div>
          <h3 className="kh-footer-heading">Get in Touch</h3>
          <div className="kh-footer-col">
            <a href="mailto:info@klikitech.com" className="kh-footer-link">info@klikitech.com</a>
            <a href="tel:0717123790" className="kh-footer-link">071 712 3790</a>
            <a href="https://wa.me/94717123790" className="kh-footer-link">WhatsApp: 071 712 3790</a>
          </div>
        </div>
      </div>

      <div className="kh-footer-bottom">
        <p style={{ fontSize: 13, color: 'var(--footer-muted)' }}>&copy; {new Date().getFullYear()} KLIK Innovatech Pvt Ltd. All rights reserved.</p>
        <div style={{ display: 'flex', gap: 22 }}>
          <a href="#!" className="kh-footer-link">Privacy Policy</a>
          <a href="#!" className="kh-footer-link">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
}
